import {
    useEffect,
    type FC
} from "react";
import type IStateCardProps from "./type";
import {
    getEmptyPropsFromStateCard
} from "./util";
import {
    warnOnce
} from "../../utils/development";
import Empty from "../empty";

const StateCard: FC<IStateCardProps> = (props) => {
    const {
        emptyProps,
        children
    } = getEmptyPropsFromStateCard({
        props
    });

    useEffect(() => {
        warnOnce({
            message: "StateCard is deprecated and will be removed in the next major version. Use Empty instead."
        });
    }, []);

    return <Empty
        {...emptyProps}
    >
        {children}
    </Empty>;
};
export default StateCard;
